export default __webpack_public_path__ + "5069ca1016cfa25bb38bdefd7b5677be.png";